$(document).ready(function(){

  /* newsletter signup form */

  if ($('#pc-newsletter-form').length) {

    $('#pc-newsletter-form').validate({
      // debug: true,
      errorElement: 'span',
      errorClass: 'form-field-error',
      validClass: 'form-field-valid',
      errorPlacement: function (error, element) {
        error.appendTo(element.parents('.form-field'));
      },
      highlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
      },
      rules: {
        'pc-newsletter-email': {
          required: true,
          email: true
        }
      },
      messages: {
        'pc-newsletter-email': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.'
        }
      },
      submitHandler: function(form) {

        $('.button-spinner', form).prop('disabled', true);

        var name = $('#pc-newsletter-name').val();
        var email = $('#pc-newsletter-email').val();
        var nonce = $('#pc-newsletter-form-nonce').val();

        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'parkchirp_newsletter_subscribe',
            name: name,
            email: email,
            nonce: nonce
          },
          success: function(results) {
            var results = $.parseJSON(results);
            console.log(results);
            $('.pc-newsletter-message', form).removeClass('pc-newsletter-message-error').addClass('pc-newsletter-message-success').text(results.message);
            $('.button-spinner', form).prop('disabled', false);
          },
          error: function(results) {
            var results = $.parseJSON(results);
            console.log(results);
            $('.pc-newsletter-message', form).removeClass('pc-newsletter-message-success').addClass('pc-newsletter-message-error').text(results.message);
            $('.button-spinner', form).prop('disabled', false);
          }
        });
      }
    });
  }

  /* home page functionality */
  if ($('body').hasClass('page-template-page-parkchirp-home')) {

    // get local timezone
    var today = new Date();
    var timezoneOffset = today.getTimezoneOffset();
    var offset = (timezoneOffset * 60) * -1;
    $('#address').attr('data-offset', offset);

    autocomplete();
    initialSearchForm();
  }

  // toggle active screenshots on click
  if ($('.pc-mobile-apps-screenshots').length) {
    $('.pc-mobile-apps-screenshots').each(function(){
      $('.pc-mobile-apps-screenshot', this).click(function(){
        if (!$(this).hasClass('pc-mobile-apps-screenshot-active')) {
          $('.pc-mobile-apps-screenshot').removeClass('pc-mobile-apps-screenshot-active');
          $(this).addClass('pc-mobile-apps-screenshot-active');
        }
      });
    });
  }

  // app reviews slider on home page
  if ($('.pc-reviews-slider').length) {
    $('.pc-reviews-slider').each(function(index, group){
      var reviewsCount = $('.pc-review', group).length;
      if (reviewsCount > 1) {
        var reviews_slider = $('.pc-reviews-group', group).flickity({
          adaptiveHeight: true,
          autoPlay: true,
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          percentPosition: true,
          prevNextButtons: false,
          wrapAround: true
        });
        reviews_slider.on('change.flickity', function(event, index) {
          $('.pc-review-pager-link', group).removeClass('active');
          $('.pc-review-pager-link[data-slide-index="' + index + '"]', group).addClass('active');
        });
        $('.pc-review-pager-link', group).on('click', function(e) {
          e.preventDefault();
          var index = $(this).attr('data-slide-index');
          $('.pc-review-pager-link', group).removeClass('active');
          $(this).addClass('active');
          reviews_slider.flickity('select', index, true, false);
        });
      }
    });
  }

});
